import { type FC } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { InteractiveGif } from '../../../image'
import VidPhoneScanningNFC from '../../images/VidPhoneScanningNFC.gif'
import { NfcLandingPageTitle } from '../NfcLandingPageTitle/NfcLandingPageTitle'
import { nfcLandingPageTextAccentNowrap } from '../NfcLandingPageTranslationValues'

import { NfcLandingPageHowItWorksSectionAppBannerDesktop } from './NfcLandingPageHowItWorksSectionAppBannerDesktop'
import { NfcLandingPageHowItWorksSectionAppBannerMobile } from './NfcLandingPageHowItWorksSectionAppBannerMobile'
import { NfcLandingPageHowItWorksSectionSteps } from './NfcLandingPageHowItWorksSectionSteps'

export const NFC_HOW_DOES_IT_WORK_SECTION_ID = 'how-does-nfc-work'

export const NfcLandingPageHowItWorksSection: FC = () => {
  const intl = useIntl()

  return (
    <div
      className="container flex flex-col gap-9 tablet:gap-12 tablet:py-12"
      id={NFC_HOW_DOES_IT_WORK_SECTION_ID}
    >
      <div className="block desktop:hidden">
        <NfcLandingPageHowItWorksSectionAppBannerMobile />
      </div>

      <div className="hidden desktop:block">
        <NfcLandingPageHowItWorksSectionAppBannerDesktop />
      </div>

      <div className="flex flex-col items-center gap-4 tablet:flex-row tablet:gap-16">
        <InteractiveGif
          alt={intl.formatMessage({
            id: 'nfc.howItWorks.images.phoneScanningCard',
          })}
          className="w-40 object-contain tablet:w-96"
          src={VidPhoneScanningNFC}
        />

        <div className="flex w-full flex-col justify-center tablet:w-3/5">
          <NfcLandingPageTitle className="mb-4 tablet:mb-6 tablet:px-0">
            <FormattedMessage
              id="nfc.howItWorks.title"
              values={{
                accentuate: nfcLandingPageTextAccentNowrap,
              }}
            />
          </NfcLandingPageTitle>
          <div className="mb-4 text-s tablet:mb-6 tablet:text-m">
            <FormattedMessage id="nfc.howItWorks.description" />
          </div>
          <NfcLandingPageHowItWorksSectionSteps />
        </div>
      </div>
    </div>
  )
}
